const r = (n) => {
  const t = n.trim().split(" ");
  return t.length > 1 ? `${t[0][0]}${t[t.length - 1][0]}` : t[0][0];
};
export {
  r as getInitials
};
//# sourceMappingURL=index.es5717.js.map
